// @ts-expect-error
import type {DataProxy, FetchResult} from 'react-apollo';

import type {
    GetCalendarSync as GetCalendarSyncQuery,
    setOffice365CalendarSyncIsEnabled as setOffice365CalendarSyncIsEnabledMutation,
    setGoogleCalendarSyncIsEnabled as setGoogleCalendarSyncIsEnabledMutation,
    SetCalendarSyncImportIsEnabled as SetCalendarSyncImportIsEnabledMutation,
} from 'nutshell-graphql-types';

import {getCalendarSync} from '../integrations/integration-mutation-response-helpers';

import GET_CALENDAR_SYNC_QUERY from './graphql/queries/get-calendar-sync.graphql';

type MutationResult =
    | FetchResult<setOffice365CalendarSyncIsEnabledMutation>
    | FetchResult<setGoogleCalendarSyncIsEnabledMutation>
    | FetchResult<SetCalendarSyncImportIsEnabledMutation>;

export function updateCacheFromMutation(proxy: DataProxy, mutationResult: MutationResult) {
    const newCalendarSync = getCalendarSync(mutationResult);
    if (!newCalendarSync) {
        return;
    }

    const cacheResult: GetCalendarSyncQuery | null | undefined = proxy.readQuery({
        query: GET_CALENDAR_SYNC_QUERY,
    });

    if (cacheResult) {
        proxy.writeQuery({
            query: GET_CALENDAR_SYNC_QUERY,
            data: {
                loggedInUser: {
                    ...cacheResult.loggedInUser,
                    calendarSync: newCalendarSync,
                },
            },
        });
    }
}
